import Vue from "vue";

export function _captionFecha(fecha) {
  if (fecha) {
    return (
      fecha.substring(8, 10) +
      "/" +
      fecha.substring(5, 7) +
      "/" +
      fecha.substring(0, 4)
    );
  } else {
    return "";
  }
}

export function _captionBicisNumero(modelReserva) {
  let res = "";
  for (let index = 0; index < modelReserva.bicis.length; index++) {
    res =
      res +
      modelReserva.bicis[index].talla +
      modelReserva.bicis[index].numero.toString() +
      ", ";
  }
  return res.slice(0, -2);
}

export async function reportePresupuesto(
  context,
  [
    modelReserva,
    presupuestoImagen1,
    presupuestoImagen2,
    presupuestoImagen3,
    presupuestoImagen4,
    presupuestoImagen5,
    presupuestoImagen6,
    presupuestoImagen7,
    presupuestoImagen8,
    presupuestoImagen12,
    presupuestoImagen13,
    presupuestoImagen14,
    tarifaSEUR,
    tarifaKm,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    tarifaMenosDe7,
    tarifaMasDe7
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 10],

    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text: "EBIKE COMPOSTELA",
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 16,
        text: "ALQUILER DE BICICLETAS ELÉCTRICAS y MUSCULARES",
        bold: true,
        alignment: "left",
        color: "#1E88E5",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 14,
        text: "BIANCHI E-VERTIC X-TYPE --- CUBE REACTION HYBRID RACE 625",
        bold: true,
        alignment: "left",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 14,
        text: "                    Muscular: ORBEA OIZ H30",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 20, 0, 10],
        fontSize: 12,
        text: "Podrás escoger la talla que mejor se adapte según tu estatura:",
        alignment: "left",
      },

      {
        columns: [
          {
            width: "auto",
            fit: [30, 80],
            image: presupuestoImagen1,
          },

          {
            margin: [0, 0, 0, 0],
            table: {
              widths: [40, "*"],
              body: [
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Talla S: desde 1,45 a 1,65 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Talla M: desde 1,65 a 1,80 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Talla L: desde 1,75 a 1,90 metros",
                ],
               
              ],
            },
            layout: "noBorders",
          },
        ],
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 12,
        text: "Características de nuestras bicis ELÉCTRICAS:",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   Su motor proporciona asistencia para el pedaleo, ajustada con una configuración especifica de bicicleta de montaña para optimizar la bicicleta tanto en conducción suave, como brusca y todoterreno.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   El sofisticado motor Bosch Drive CX de cuarta generaciónde todas nuestras bicicletas, utiliza una batería Bosch  de 625 wh, lo que significa que ninguna pendiente pronunciada o una larga resistencia podrá con ella.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 12,
        text: "Características de nuestras bicis MUSCULARES:",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   Bicicleta de aluminio Orbea Oiz H30, con transmisión Shimano Deore de 12 velocidades y horquilla Fox 32 Float Rhythm de 120 mm de recorrido con control remoto.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              {
                width: "auto",
                fit: [40, 100],
                image: presupuestoImagen2,
              },
              {
                text: "Recibirás la bicicleta en tu domicilio, el día que tú nos digas. Trabajamos con Seur. Para ello necesitamos conocer tu fecha de salida con mínimo tres días de antelación.",
                alignment: "left",
                fontSize: 10,
                color: "#AAAAAA",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Cuando termines tú ruta, no te preocupes por la bici, nosotros nos encargamos de recogerla donde más cómodo te sea.",
        alignment: "left",
        color: "#1E88E5",
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [60, "*", 60, 180],
          body: [
            [
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen3,
              },
              {
                text: [
                  {text: "Los puntos de devolución de bicicletas:", bold: true, fontSize: 10}, 
                  "\n Santiago \n Fisterra (coste adicional 10 €)"],
                fontSize: 10,
                alignment: "left",
              },
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen4,
              },
              {
                text: [{text: "Tarifas:", bold: true, fontSize: 10}, 
                "\n Alquiler de 1 día:             55 €/día \n " +
                     "Alquiler de 2 a 7 días:    45 €/día \n " + 
                     "Alquiler de 8 a 15 días:  40 €/día \n " ],
                fontSize: 10,
                alignment: "left",
              },
            ],
          
            [
              { text: "" },
              { text: "" },
              { text: "" },
              { text: "", alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen5,
                alignment: "center",
              },
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen6,
                alignment: "center",
              },
            ],
            [
              {
                text: "Bianchi E-Vertic X Type",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "Cube Reaction Hybrid Race 625",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen12,
                alignment: "center",
              },
              {
                margin: [60, 30, 0, 0],
                text: [{text: "Tarifas Bici Muscular:", bold: true}, 
                "\n Alquiler de 1 día:             45 €/día \n " +
                     "Alquiler de 2 a 7 días:    35 €/día \n " + 
                     "Alquiler de 8 a 15 días:  30 €/día \n " ],
                fontSize: 10,
                alignment: "left",
              },
            ],
            [
              {
                text: "Orbea Oiz H 30",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },



      {
        margin: [0, 10, 0, 0],
        width: "auto",
        fit: [40, 100],
        image: presupuestoImagen7,
        alignment: "right",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text:
                  "PRESUPUESTO " +
                  modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
                  "_" +
                  (modelReserva.id > 507?(modelReserva.id - 507):modelReserva.id),
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              { text: "Fecha:" },
              { text: _captionFecha(modelReserva.created_at) },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [120, 120, 120, "*"],
          body: [
            [
              { text: "Fecha Inicio Alquiler:" },
              { text: _captionFecha(modelReserva.fecha_inicial), alignment: "left" },
              { text: "Lugar de Entrega:" },
              { text: modelReserva.ubicacion_inicial, alignment: "left" },
            ],
            [
              { text: "Fecha Fin Alquiler:" },
              { text: _captionFecha(modelReserva.fecha_final), alignment: "left" },
              { text: "Lugar de Recogida:" },
              { text: modelReserva.ubicacion_final, alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "PRECIO ALQUILER EBIKE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: [80, "*", "*", "*", "*"],
          body: [
            [
              { text: "Talla", bold: true, alignment: "center" },
              { text: "Unidades", bold: true, alignment: "center" },
              { text: "Nº de días", bold: true, alignment: "center" },
              { text: "Precio por día", bold: true, alignment: "right" },
              { text: "Importe", bold: true, alignment: "right" },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "PRECIO de TRANSPORTE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*", "*"],
          body: [
            [
              { text: "Nº de bicicletas", bold: true, alignment: "center" },
              { text: "Km", bold: true, alignment: "center" },
              { text: "SEUR", bold: true, alignment: "right" },
              { text: "Precio Km", bold: true, alignment: "right" },
              { text: "Importe", bold: true, alignment: "right" },
            ],

            [
              { text: modelReserva.cant_bicis, alignment: "center" },
              {
                text: modelReserva.transporte_km,
                alignment: "center",
              },
              { text: tarifaSEUR + " €", alignment: "right" },
              { text: tarifaKm + " €", alignment: "right" },
              {
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", 100],
          body: [
            [
              { text: "TOTAL PRESUPUESTO", bold: true, alignment: "right" },
              {
                text: modelReserva.importe + " €",
                bold: true,
                alignment: "right",
              },
            ],
            modelReserva.descuento != null &&
            modelReserva.descuento != "" &&
            modelReserva.descuento != 0.0
              ? [
                  { text: "DESCUENTO", bold: true, alignment: "right" },
                  {
                    text: modelReserva.descuento + " €",
                    bold: true,
                    alignment: "right",
                  },
                ]
              : ["", ""],

            [
              { text: "FIANZA", bold: true, alignment: "right" },
              {
                text: modelReserva.fianza + " €",
                bold: true,
                alignment: "right",
              },
            ],

            [
              { text: "TOTAL A PAGAR", bold: true, alignment: "right" },
              {
                text: modelReserva.total + " €",
                bold: true,
                alignment: "right",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        text: "(Precios con IVA Incluido)", fontSize: 10
      },
      {
        text: "La fianza se devuelve al finalizar el alquiler.", fontSize: 10,
        
      },
      {
        margin: [0, 5, 0, 0],
        text: "Forma de pago:",
        fontSize: 10,
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% del presupuesto, ",
          { text: "sin la fianza", color: "#FF0000" },
          ", para formalizar la reserva.",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "Resto al iniciar el alquiler.",
          
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: " IBAN ES83 2080 0306 5130 4002 5574",
                alignment: "left",
              },
              { text: "" },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "BIC: CAGLESMMXXX",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Bizum 699 331 965",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        text: [
          {text: "Incluye:\n", bold : true},
          "Casco\n",
          "Kit de Pinchazos\n",
          "Luz trasera\n",
          "Alforjas (opcional sin coste)\n",
          "Candado"
        ],
        fontSize: 10,
      },




      {
        width: "auto",
        fit: [800, 50],
        image: presupuestoImagen13,
      },

      {
        margin: [40, 0, 0, 0],
        width: "auto",
        fit: [800, 110],
        image: presupuestoImagen14,
      },
    ],
  };

  var fila = [
    { text: "S", alignment: "center" },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_bicis_s : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? importe_s + " €" : " - €",
      alignment: "right",
    },
  ];
 
   if (modelReserva.cant_bicis_s > 0){
    docDefinition.content[21].table.body.push(fila);
   }
 
 
  fila = [
    { text: "M", alignment: "center" },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_bicis_m : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? importe_m + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_m > 0){
    docDefinition.content[21].table.body.push(fila);
   }
  fila = [
    { text: "L", alignment: "center" },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_bicis_l : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? importe_l + " €" : " -€",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_l > 0){
    docDefinition.content[21].table.body.push(fila);
   }
  fila = [
    { text: "XL", alignment: "center" },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_bicis_xl : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_xl > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? importe_xl + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_xl > 0){
    docDefinition.content[21].table.body.push(fila);
   }

   fila = [
    { text: "MS", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_bicis_ms : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ms > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? importe_ms + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ms > 0){
    docDefinition.content[21].table.body.push(fila);
   }

  fila = [
    { text: "MM", alignment: "center" },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_bicis_mm : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_mm > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? importe_mm + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_mm > 0){
    docDefinition.content[21].table.body.push(fila);
   }

  fila = [
    { text: "ML", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_bicis_ml : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ml > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? importe_ml + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ml > 0){
    docDefinition.content[21].table.body.push(fila);
   }

  return docDefinition;
}

export async function reportePresupuestoIngles(
  context,
  [
    modelReserva,
    presupuestoImagen1,
    presupuestoImagen2,
    presupuestoImagen3,
    presupuestoImagen4,
    presupuestoImagen5,
    presupuestoImagen6,
    presupuestoImagen7,
    presupuestoImagen8,
    presupuestoImagen12,
    presupuestoImagen13,
    presupuestoImagen14,
    tarifaSEUR,
    tarifaKm,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    tarifaMenosDe7,
    tarifaMasDe7
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 10],

    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text: "EBIKE COMPOSTELA",
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 16,
        text: "ELECTRIC BICYCLES RENTAL",
        bold: true,
        alignment: "left",
        color: "#1E88E5",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 14,
        text: "BIANCHI E-VERTIC X-TYPE --- CUBE REACTION HYBRID RACE 625",
        bold: true,
        alignment: "left",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 14,
        text: "                    Muscular: ORBEA OIZ H30",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 20, 0, 10],
        fontSize: 12,
        text: "You will be able to choose the size that best suits your height:",
        alignment: "left",
      },

      {
        columns: [
          {
            width: "auto",
            fit: [30, 80],
            image: presupuestoImagen1,
          },

          {
            margin: [0, 0, 0, 0],
            table: {
              widths: [40, "*"],
              body: [
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Size S: from 1,45 to 1,65 meters",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Size M: from 1,65 a 1,80 meters",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Size L: from 1,75 a 1,90 meters",
                ],
               
              ],
            },
            layout: "noBorders",
          },
        ],
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 12,
        text: "Features of our electric bikes:",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   Its motor provides pedal assist, tuned with mountain bike-specific settings to optimize the bike for smooth, rough and off-road riding.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   The 250w motor is powered by a 540wh battery and has 5 powerful levels of assistance at your disposal, meaning you can handle any incline or long resistance.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 12,
        text: "Features of our muscle bikes:",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   Orbea Oiz H30 aluminum bicycle, with Shimano Deore 12-speed transmission and Fox 32 Float Rhythm fork with 120 mm travel with remote control.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              {
                width: "auto",
                fit: [40, 100],
                image: presupuestoImagen2,
              },
              {
                text: "You will receive the bike at your home, the day you tell us. We work with Seur. For this we need to know your departure date at least three days in advance.",
                alignment: "left",
                fontSize: 10,
                color: "#AAAAAA",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "When you finish your route, do not worry about the bike, we will pick it up where it is most convenient for you.",
        alignment: "left",
        color: "#1E88E5",
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [60, "*", 60, 180],
          body: [
            [
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen3,
              },
              {
                text: [
                  {text: "The points of return of bicycles:", bold: true, fontSize: 10}, 
                  "\n Santiago \n Fisterra (coste adicional 10 €)"],
                fontSize: 10,
                alignment: "left",
              },
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen4,
              },
              {
                text: [{text: "Rates:", bold: true, fontSize: 10}, 
                "\n Rental from 1 day:             55 €/day \n " +
                     "Rental from 2 to 7 days:    45 €/day \n " + 
                     "Rental from 8 to 15 days:  40 €/day \n " ],
                fontSize: 10,
                alignment: "left",
              },
            ],
          
            [
              { text: "" },
              { text: "" },
              { text: "" },
              { text: "", alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen5,
                alignment: "center",
              },
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen6,
                alignment: "center",
              },
            ],
            [
              {
                text: "Bianchi E-Vertic X Type",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "Cube Reaction Hybrid Race 625",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen12,
                alignment: "center",
              },
              {
                margin: [60, 30, 0, 0],
                text: [{text: "Rates Muscle Bike:", bold: true}, 
                "\n Rental from 1 day:             45 €/day \n " +
                     "Rental from 2 a 7 days:    35 €/day \n " + 
                     "Rental from 8 a 15 days:  30 €/day \n " ],
                fontSize: 10,
                alignment: "left",
              },
            ],
            [
              {
                text: "Orbea Oiz H 30",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },



      {
        margin: [0, 10, 0, 0],
        width: "auto",
        fit: [40, 100],
        image: presupuestoImagen7,
        alignment: "right",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text:
                  "BUDGET " +
                  modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
                  "_" +
                  modelReserva.id,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              { text: "Date:" },
              { text: _captionFecha(modelReserva.created_at) },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [120, 120, 120, "*"],
          body: [
            [
              { text: "Start date:" },
              { text: _captionFecha(modelReserva.fecha_inicial), alignment: "left" },
              { text: "Delivery:" },
              { text: modelReserva.ubicacion_inicial, alignment: "left" },
            ],
            [
              { text: "End date:" },
              { text: _captionFecha(modelReserva.fecha_final), alignment: "left" },
              { text: "Pick Up:" },
              { text: modelReserva.ubicacion_final, alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "EBIKE RENTAL PRICE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: [80, "*", "*", "*", "*"],
          body: [
            [
              { text: "Size", bold: true, alignment: "center" },
              { text: "Units", bold: true, alignment: "center" },
              { text: "Nº of days", bold: true, alignment: "center" },
              { text: "Price/day", bold: true, alignment: "right" },
              { text: "Amount", bold: true, alignment: "right" },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "TRANSPORT PRICE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*", "*"],
          body: [
            [
              { text: "Nº of bikes", bold: true, alignment: "center" },
              { text: "Km", bold: true, alignment: "center" },
              { text: "SEUR", bold: true, alignment: "right" },
              { text: "Price", bold: true, alignment: "right" },
              { text: "Amount", bold: true, alignment: "right" },
            ],

            [
              { text: modelReserva.cant_bicis, alignment: "center" },
              {
                text: modelReserva.transporte_km,
                alignment: "center",
              },
              { text: tarifaSEUR + " €", alignment: "right" },
              { text: tarifaKm + " €", alignment: "right" },
              {
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", 100],
          body: [
            [
              { text: "TOTAL BUDGET", bold: true, alignment: "right" },
              {
                text: modelReserva.importe + " €",
                bold: true,
                alignment: "right",
              },
            ],
            modelReserva.descuento != null &&
            modelReserva.descuento != "" &&
            modelReserva.descuento != 0.0
              ? [
                  { text: "DISCOUNT", bold: true, alignment: "right" },
                  {
                    text: modelReserva.descuento + " €",
                    bold: true,
                    alignment: "right",
                  },
                ]
              : ["", ""],

            [
              { text: "DEPOSIT", bold: true, alignment: "right" },
              {
                text: modelReserva.fianza + " €",
                bold: true,
                alignment: "right",
              },
            ],

            [
              { text: "TOTAL TO PAY", bold: true, alignment: "right" },
              {
                text: modelReserva.total + " €",
                bold: true,
                alignment: "right",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        text: "Prices include IVA", fontSize: 10
      },
      {
        text: "The deposit will be refunded at the end of the contract", fontSize: 10,
        
      },
      {
        margin: [0, 5, 0, 0],
        text: "Payment method:",
        fontSize: 10,
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: "20% to formalize the reservation, ",
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "The rest at the beginning of the rental period",
          
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: " IBAN ES83 2080 0306 5130 4002 5574",
                alignment: "left",
              },
              { text: "" },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "BIC: CAGLESMMXXX",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Bizum 699 331 965",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        text: [
          {text: "Includes:\n", bold : true},
          "Helmet\n",
          "Puncture Kit\n",
          "Rear light\n",
          "Saddlebags (optional) \n",
          "Lock"
        ],
        fontSize: 10,
      },




      {
        width: "auto",
        fit: [800, 50],
        image: presupuestoImagen13,
      },

      {
        margin: [40, 0, 0, 0],
        width: "auto",
        fit: [800, 110],
        image: presupuestoImagen14,
      },
    ],
  };

  var fila = [
    { text: "S", alignment: "center" },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_bicis_s : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? importe_s + " €" : " - €",
      alignment: "right",
    },
  ];
 
   if (modelReserva.cant_bicis_s > 0){
    docDefinition.content[21].table.body.push(fila);
   }
 
 
  fila = [
    { text: "M", alignment: "center" },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_bicis_m : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? importe_m + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_m > 0){
    docDefinition.content[21].table.body.push(fila);
   }
  fila = [
    { text: "L", alignment: "center" },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_bicis_l : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? importe_l + " €" : " -€",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_l > 0){
    docDefinition.content[21].table.body.push(fila);
   }
  fila = [
    { text: "XL", alignment: "center" },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_bicis_xl : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_xl > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? importe_xl + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_xl > 0){
    docDefinition.content[21].table.body.push(fila);
   }

   fila = [
    { text: "MS", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_bicis_ms : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ms > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? importe_ms + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ms > 0){
    docDefinition.content[21].table.body.push(fila);
   }

  fila = [
    { text: "MM", alignment: "center" },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_bicis_mm : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_mm > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? importe_mm + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_mm > 0){
    docDefinition.content[21].table.body.push(fila);
   }

  fila = [
    { text: "ML", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_bicis_ml : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ml > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? importe_ml + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ml > 0){
    docDefinition.content[21].table.body.push(fila);
   }

  return docDefinition;
}

export async function reporteConfirmacion(
  context,
  [
    con_condiciones,
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    campoConfirmacionFecha
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Confirmación Reserva Alquiler",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                colSpan: 2,
                border: [false, false, false, true],
                fontSize: 14,
                text: "ALQUILER DE BICICLETA ELÉCTRICA",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Fecha de Reserva: ",
                bold: true,
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(campoConfirmacionFecha),
                bold: true,
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Presupuesto: ",
                bold: true,
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
                  "_" +
                  modelReserva.id,
                bold: true,
              },
            ],
            [
              {
                colSpan: 2,
                border: [false, false, false, false],
                fontSize: 10,
                text: "Datos Cliente: ",
                bold: true,
              },
              "",
            ],
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Nombre:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "D.N.I:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Dirección:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Teléfono Contacto:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Email:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Datos Alquiler:",
        bold: true,
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, 80, "*", 20, 20, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Inicio Alquiler:",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: 
                modelReserva.cant_bicis_s > 0? 
                "S": "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0
                    ? modelReserva.cant_bicis_s
                    : "",
                alignment: "center",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Fin Alquiler:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_final),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "TALLA:",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_m > 0
                ?"M":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_m > 0
                    ? modelReserva.cant_bicis_m
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Numero de Ebikes:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_l > 0
                ?"L":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_l > 0
                    ? modelReserva.cant_bicis_l
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_xl > 0
                ?"XL":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_xl > 0
                    ? modelReserva.cant_bicis_xl
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_ms > 0
                ?"MS":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ms > 0
                    ? modelReserva.cant_bicis_ms
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Lugar de Entrega:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.ubicacion_inicial,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_mm > 0
                ?"MM":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_mm > 0
                    ? modelReserva.cant_bicis_mm
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Lugar de Recogida:",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.ubicacion_final,
              },
              {
                border: [false, false, false, true],
                text: "",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.cant_bicis_ml > 0
                ?"ML":"",
                alignment: "center",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ml > 0
                    ? modelReserva.cant_bicis_ml
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, true],
                text: "",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Datos Adicionales:",
        bold: true,
      },

      {
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Observaciones:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: modelReserva.observaciones,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Alquiler de GPS:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.gps ? "Sí" : "No",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Asistencia en viaje:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: "No",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [120, 40, 80, 80, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "TARIFA:",
                bold: true,
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "Nº",
                bold: true,
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "PVP   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "TOTAL   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALQUILER",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_s + modelReserva.cant_bicis_m + 
                                                modelReserva.cant_bicis_l + modelReserva.cant_bicis_xl),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(
                    parseFloat(importe_s) +
                      parseFloat(importe_m) +
                      parseFloat(importe_l) +
                      parseFloat(importe_xl)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALQUILER MUSC",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio_m,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(parseFloat(importe_ms) +
                    parseFloat(importe_mm) +
                      parseFloat(importe_ml)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "TRANSPORTE",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [true, false, false, false],
                fontSize: 10,
                text: "FIANZA",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.fianza + " €",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            modelReserva.descuento != null &&
            modelReserva.descuento != "" &&
            modelReserva.descuento != 0.0
              ? [
                  {
                    margin: [0, 0, 0, 20],
                    border: [true, false, false, true],
                    fontSize: 10,
                    text: "DESCUENTO",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                    alignment: "center",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                    alignment: "right",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, true, true],
                    fontSize: 10,
                    text: modelReserva.descuento + " €",
                    alignment: "right",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, false, false],
                    text: "",
                  },
                ]
              : [
                  {
                    border: [true, false, false, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, true, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, false, false],
                    text: "",
                  },
                ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PAGADO ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pagado + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PENDIENTE ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pendiente + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 40, 0, 0],
        fontSize: 12,
        text: "FORMA DE PAGO:",
        italics: true,
        bold: true,
      },
      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "EFECTIVO - BIZUM: 699331965",
        italics: true,
        bold: true,
        color: "#1E88E5",
      },
      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "Nº de Cuenta: IBAN: ES83 2080 0306 5130 4002 5574",
        italics: true,
        bold: true,
        color: "#1E88E5",
      },
      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "La cantidad restante, pendiente de pago debe ser abonada 2 días antes al envio de las bicicletas por Seur.",
        italics: true,
        bold: true,
        color: "#1E88E5",
      },

      con_condiciones
        ? {
            margin: [0, 30, 0, 0],
            table: {
              widths: ["*", "*"],
              body: [
                [
                  {
                    colSpan: 2,
                    margin: [0, 60, 0, 20],
                    fontSize: 18,
                    text: "\n\nTÉRMINOS Y CONDICIONES:",
                    bold: true,
                    alignment: "left",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "1.- Las bicicletas se recogerán y entregarán en el horario establecido que va desde las 08:00 horas a las 21:00 horas todos los días de la semana.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: [
                      "2.- La devolución de la/s bicicleta/ y material alquilado se llevará a cabo en el lugar del arrendamiento, el día ",
                      {
                        text: _captionFecha(modelReserva.fecha_final),
                        fontSize: 10,
                        bold: true,
                      },
                      " a la hora 21:00. El incumplimiento de la hora de entrega ocasionará un cargo adicional al cliente de 10 euros por hora de retraso. De no realizar la entrega en el día estipulado en el contrato, el cargo adicional ocasionado, será de 35 euros. Al no realizar la entrega, el arrendador podrá tomar posesión inmediata la bicicleta en el lugar donde se encuentre, sin tener derecho a reclamación alguna por parte del arrendatario.",
                    ],
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "3.- La franja horaria de alquiler queda comprendida: Día completo: 08:00 a 21:00 horas.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "4.- El material se devolverá completo y en el mismo estado en el que se le entregó al cliente. El coste por reparación o reposición de la bicicleta y/o del material correrá a cargo del cliente. El cliente deberá informar al arrendador, de los daños ocasionados en dicho material o del mal funcionamiento del mismo. El cliente esta obligado a tener buen cuidado y tomar todas las precauciones necesarias para proteger las bicicletas y el equipo alquilado de daños, perdida o robo. De producirse cualquiera de las mencionadas situaciones durante el periodo de alquiler, el cliente asumirá de manera inmediata la totalidad de los costes de reposición ocasionados a precio de tarifa o de mercado según el arrendador disponga o no de la pieza a reponer. Al final del periodo de alquiler el arrendador, determinará las condiciones de entrega del material alquilado y valorará dado el caso, las pérdidas o daños ocasionados. El cliente está obligado en todo momento a fijar correctamente con el candado y cadena de seguridad la/s bicicleta/s cuando no las tenga a la vista (pasar el candado por el cuadro, sillín y ruedas y atar la bicicleta aun poste fijado al suelo o bici parking).",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "5.- El arrendatario declara estar en perfectas condiciones de salud, ser capaz de manejar una bicicleta y poseer el control necesario del equipamiento alquilado.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: [
                      "6.- En este acto el arrendatario entrega al arrendador, una ",
                      {
                        text: "fianza de " + modelReserva.fianza + " euros",
                        fontSize: 10,
                        bold: true,
                      },
                      " que servirá para responder de los posibles daños causados a la bicicleta o el equipamiento alquilado, dicha fianza será reembolsada al finalizar el contrato. En caso de pérdida o robo de la bicicleta, el arrendador perderá todo el derecho a la fianza, debiendo comunicar de inmediato tal circunstancia. Además, deberá proceder a indemnizar al arrendatario por la cantidad estipulada según precio de mercado.",
                    ],
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "7.- El alquiler de bicicleta no incluye seguro de daños propios, por lo que el arrendatario es responsable de todos los daños de material o personales que pueda sufrir. El alquiler se realiza con la cobertura del correspondiente seguro de RC que cubre todos los daños causados por origen del alquiler a terceros, personas o bienes. Es responsabilidad del cliente y de su/s acompañante/s respetar las normas de tráfico españolas y conducir con cuidado y respetar a los peatones.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "8.- Los datos facilitados por el cliente, serán utilizados exclusivamente para la correcta prestación del servicio contratado, pudiendo solicitar, de acuerdo con la ley, su acceso, rectificación, cancelación u oposición mediante comunicación por cualquier medio al arrendador. Este contrato se rige por la ley española.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "9.- En caso de que el arrendador necesite asistencía en viaje sin que hubiese sido contratada con anterioridad, el coste será de 15€ hora, y 15€ de desplazamiento a la zona donde se encuentre el cliente.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "10.- En caso de que el arrendador decida devolver las bicicletas en fecha anterior a la finalizacion de este contrato, no tendrá derecho a la devolución alguna.",
                  },
                  "",
                ],
                [
                  {
                    margin: [0, 40, 0, 0],
                    fontSize: 10,
                    bold: true,
                    text: "Firma del Arrendador",
                  },
                  {
                    margin: [0, 40, 0, 0],
                    fontSize: 10,
                    bold: true,
                    text: "Firma del Arrendatario - Contratante",
                  },
                ],

                [
                  {
                    width: "auto",
                    fit: [180, 100],
                    image: imagenFirma,
                    alignment: "left",
                  },

                  {
                    text: "",
                  },
                ],
              ],
            },
            layout: "noBorders",
          }
        : "",
    ],
  };

  return docDefinition;
}

export async function reporteConfirmacionIngles(
  context,
  [
    con_condiciones,
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    campoConfirmacionFecha
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Booking Boucher",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                colSpan: 2,
                border: [false, false, false, true],
                fontSize: 14,
                text: "ELECTRIC BIKE RENTAL",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Date: ",
                bold: true,
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(campoConfirmacionFecha),
                bold: true,
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nº Budget: ",
                bold: true,
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
                  "_" +
                  modelReserva.id,
                bold: true,
              },
            ],
            [
              {
                colSpan: 2,
                border: [false, false, false, false],
                fontSize: 10,
                text: "Customer Information: ",
                bold: true,
              },
              "",
            ],
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Name and Surname:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Nº Passport:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Address:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Phone number:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Email:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Rental data:",
        bold: true,
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, 80, "*", 20, 20, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Start Rent:",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: 
                modelReserva.cant_bicis_s > 0? 
                "S": "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0
                    ? modelReserva.cant_bicis_s
                    : "",
                alignment: "center",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Finish Rent:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_final),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Sizes:",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_m > 0
                ?"M":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_m > 0
                    ? modelReserva.cant_bicis_m
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Number of bikes:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_l > 0
                ?"L":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_l > 0
                    ? modelReserva.cant_bicis_l
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_xl > 0
                ?"XL":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_xl > 0
                    ? modelReserva.cant_bicis_xl
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_ms > 0
                ?"MS":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ms > 0
                    ? modelReserva.cant_bicis_ms
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Place of delivery:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.ubicacion_inicial,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_mm > 0
                ?"MM":"",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_mm > 0
                    ? modelReserva.cant_bicis_mm
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Pickup location:",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.ubicacion_final,
              },
              {
                border: [false, false, false, true],
                text: "",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.cant_bicis_ml > 0
                ?"ML":"",
                alignment: "center",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ml > 0
                    ? modelReserva.cant_bicis_ml
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, true],
                text: "",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Additional information:",
        bold: true,
      },

      {
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Observations:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: modelReserva.observaciones,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "GPS Rental:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.gps ? "Sí" : "No",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Travel Assistance:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: "No",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [120, 40, 80, 80, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "PRICES:",
                bold: true,
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "Nº",
                bold: true,
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "PVP   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "TOTAL   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "RENT",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_s + modelReserva.cant_bicis_m + 
                                                modelReserva.cant_bicis_l + modelReserva.cant_bicis_xl),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(
                    parseFloat(importe_s) +
                      parseFloat(importe_m) +
                      parseFloat(importe_l) +
                      parseFloat(importe_xl)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "RENT MUSC",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio_m,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat( parseFloat(importe_ms) +
                    parseFloat(importe_mm) +
                      parseFloat(importe_ml)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "TRANSPORTATION",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [true, false, false, false],
                fontSize: 10,
                text: "DEPOSIT",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.fianza + " €",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            modelReserva.descuento != null &&
            modelReserva.descuento != "" &&
            modelReserva.descuento != 0.0
              ? [
                  {
                    margin: [0, 0, 0, 20],
                    border: [true, false, false, true],
                    fontSize: 10,
                    text: "DISCOUNT",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                    alignment: "center",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                    alignment: "right",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, true, true],
                    fontSize: 10,
                    text: modelReserva.descuento + " €",
                    alignment: "right",
                  },
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, false, false, false],
                    text: "",
                  },
                ]
              : [
                  {
                    border: [true, false, false, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, false, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, true, true],
                    fontSize: 10,
                    text: "",
                  },
                  {
                    border: [false, false, false, false],
                    text: "",
                  },
                ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 8,
                text: "PAID OUT ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pagado + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 8,
                text: "PENDING PAYMENT ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pendiente + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 40, 0, 0],
        fontSize: 12,
        text: "PAYMENT METHOD:",
        italics: true,
        bold: true,
      },
      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "CASH - BIZUM: 699331965",
        italics: true,
        bold: true,
        color: "#1E88E5",
      },
      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "ACCOUNT NUMBER: IBAN: ES83 2080 0306 5130 4002 5574",
        italics: true,
        bold: true,
        color: "#1E88E5",
      },
      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "The remaining amount, pending payment, must be paid 2 days before the shipment of the bikes.",
        italics: true,
        bold: true,
        color: "#1E88E5",
      },

      con_condiciones
        ? {
            margin: [0, 30, 0, 0],
            table: {
              widths: ["*", "*"],
              body: [
                [
                  {
                    colSpan: 2,
                    margin: [0, 60, 0, 20],
                    fontSize: 18,
                    text: "\n\nSPECIFIC TERMS & CONDITIONS OF THE CONTRACT ",
                    bold: true,
                    alignment: "left",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "1.- Bicycles will be picked up and brought back between the established schedule which goes from 8:00 to 21:00 every day of the week.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: [
                      "2.- The return of bicycles and any other rented material will take place at the place of rental,  On: ",
                      {
                        text: _captionFecha(modelReserva.fecha_final),
                        fontSize: 10,
                        bold: true,
                      },
                      " at 21:00. Failure to meet the delivery time will cause an additional charge to the client of 10 euros per hour of delay. If the delivery is not made on the day stipulated in the contract, the additional charge caused will be 35 euros. By not making the delivery, the lessor may take immediate possession of the bicycle in the place where it is located, without having the right to any claim by the lessee.",
                    ],
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "3.- The rental period is comprised of: Whole day: 8:00 to 21:00",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "4.- The rented material shall be returned in its entirety in the same state that the client received it. Cost for repair or replenishment of the bicycle and/or any other rented material will be client’s responsibility. They shall inform the lessor of caused damage or malfunction. They are obligated to maintain the rented material in good condition and take all necessary precaution to protect it from harm, loss and theft. If any of said situations were to happen during the lease period, the client will immediately assume the entirety of the replacement costs at tariff or market price, depending on whether or not the lessor has the part to be replaced. At the end of the lease period the lessor will determine return condition and they will assess, given the circumstances, the loss or damaged caused. The client will be obligated to verify their padlock and security chain are properly placed (pass the lock through the frame, saddle and wheels and tie the bike to a post fixed to the ground or bike parking). ",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "5.- The lessee declares they are in perfect health condition, are capable of riding a bicycle and poses necessary control over the rented material.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: [
                      "6.- In this act, the lessee submits the lessor a ",
                      {
                        text: modelReserva.fianza + " euros",
                        fontSize: 10,
                        bold: true,
                      },
                      " bail trough credit card which will be used as collateral for any possible damage and shall be refunded at the end of the lease. In case of loss or theft of the bicycle, the lessee will lose all right to the bail, having to communicate said circumstance right away. Moreover, they must compensate the lessor for the stipulated amount accorded to market price.",
                    ],
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "7.- This lease does not include own damage insurance, so the lessee is responsible for all material or personal damage they may suffer. The rental includes the corresponding liability insurance that covers all damages caused by the rental to third parties, people or goods. The client and their companions must obey Spanish traffic regulations, drive safely and respect pedestrians.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "8.- The data provided by the customer will be exclusively used to guarantee the correct service provision, being always able to request access, rectification, cancellation or objection by communicating with the lessor, according to the law.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "9.- In the event that the lessee needs travel assistance without having contracted it beforehand, the cost will be of 15€ per hour and 15€ to go where the client is located.",
                  },
                  "",
                ],
                [
                  {
                    colSpan: 2,
                    margin: [0, 5, 0, 0],
                    fontSize: 10,
                    text: "10.- In the event that the lessee decides to return the rented equipment on a date before the end of the contract expires, they will not be entitled to any refund.",
                  },
                  "",
                ],
                [
                  {
                    margin: [0, 40, 0, 0],
                    fontSize: 10,
                    bold: true,
                    text: "Lessor’s Signature        ",
                  },
                  {
                    margin: [0, 40, 0, 0],
                    fontSize: 10,
                    bold: true,
                    text: "Customer Signature",
                  },
                ],

                [
                  {
                    width: "auto",
                    fit: [180, 100],
                    image: imagenFirma,
                    alignment: "left",
                  },

                  {
                    text: "",
                  },
                ],
              ],
            },
            layout: "noBorders",
          }
        : "",
    ],
  };

  return docDefinition;
}

export async function reporteFactura(
  context,
  [
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    campoFacturaFilas,
    campoFacturaClienteNombre,
    campoFacturaClienteDNI,
    campoFacturaClienteDomicilio,
    campoFacturaDescripcionAlquiler,
    campoFacturaDescripcionTransporte,
    campoFacturaPrecioAlquiler,
    campoFacturaPrecioTransporte,
    campoFacturaFecha,
    campoFacturaPrecioAlquilerMuscular
  ]
) {
  var importeAlquiler = parseFloat(
    parseFloat(modelReserva.cant_bicis_s + modelReserva.cant_bicis_m + modelReserva.cant_bicis_l + modelReserva.cant_bicis_xl) *
      parseFloat(modelReserva.cant_dias) *
      parseFloat(campoFacturaPrecioAlquiler)
  ).toFixed(2);

  var importeAlquilerMuscular = parseFloat(
    parseFloat(modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml) *
      parseFloat(modelReserva.cant_dias) *
      parseFloat(campoFacturaPrecioAlquilerMuscular)
  ).toFixed(2);

  var baseImponible = parseFloat(parseFloat(importeAlquiler) + parseFloat(importeAlquilerMuscular)).toFixed(2);

  if (campoFacturaPrecioTransporte != "" && campoFacturaPrecioTransporte > 0) {
    baseImponible = parseFloat(
      parseFloat(baseImponible) + parseFloat(campoFacturaPrecioTransporte)
    ).toFixed(2);
  }

  var iva = "";
  var total = baseImponible;
  if (modelReserva.sin_iva == 0) {
    iva = parseFloat(parseFloat(baseImponible) * 0.21).toFixed(2) + " €";
    total = parseFloat(parseFloat(baseImponible) + parseFloat(iva)).toFixed(2);
  }
  
  var totalFinal = '0.00';
  if (modelReserva.descuento != null && modelReserva.descuento != '0.00'){
    totalFinal = parseFloat(parseFloat(total) - parseFloat(modelReserva.descuento)).toFixed(2);
  }

  var docDefinition = {
    info: {
        title: campoFacturaFecha.substring(0, 10).replaceAll("-", "").replaceAll("/", "") +
        "_" +
        modelReserva.id.toString() +
        "_" +
        modelReserva.cliente.nombre.replaceAll(" ", "") +
        "_Factura.pdf"
    },
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 200],
          body: [
            [
              {
                text: [
                  {
                    text: "DAVID FRAGÍO AGRA\n\n",
                    fontSize: 18,
                    bold: true,
                    color: "#0070BD",
                  },
                  "44831130-J\n",
                  "Lugar de Sabaxáns nº 48\n",
                  "15280 Brión\n",
                  "A CORUÑA\n",
                  "Tfno: 699 331 965\n\n",
                  {
                    text: "info@ebikecompostela.es\n",
                    fontSize: 10,
                    color: "#0070BD",
                  },
                  {
                    text: "www.ebikecompostela.es\n",
                    fontSize: 10,
                    color: "#0070BD",
                  },
                ],
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "center",
              },
            ],
            [
              "",
              {
                alignment: "center",
                text: [
                  modelReserva.cliente.nombre + "\n",
                  (modelReserva.cliente.dni != null
                    ? modelReserva.cliente.dni
                    : "") + "\n",
                  (modelReserva.cliente.domicilio != null
                    ? modelReserva.cliente.domicilio
                    : "") + "\n",
                ],
              },
            ],
            [
              {
                alignment: "left",
                text: [
                  "FECHA:        " +
                    _captionFecha(campoFacturaFecha) +
                    "\n\n",
                  "Nº FACTURA:   " +
                    (modelReserva.factura != null ? modelReserva.factura : "") +
                    "\n",
                ],
              },
              "",
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          heights: [15, 30, 30, 20, 60, 5],
          widths: ["*", 80, 80, 80],
          body: [
            [
              {
                fontSize: 12,
                text: " Descripción",
                fillColor: "#DCEBF7",
              },
              {
                fontSize: 12,
                text: "Unidades",
                fillColor: "#DCEBF7",
                alignment: "center",
              },
              {
                fontSize: 12,
                text: "Precio",
                fillColor: "#DCEBF7",
                alignment: "center",
              },
              {
                fontSize: 12,
                text: "IMPORTE",
                fillColor: "#DCEBF7",
                alignment: "center",
              },
            ],
            [
              {
                fontSize: 10,
                text: campoFacturaDescripcionAlquiler,
              },
              {
                fontSize: 10,
                text:
                  "\n" +
                  (modelReserva.cant_bicis_s + modelReserva.cant_bicis_m +modelReserva.cant_bicis_l +modelReserva.cant_bicis_xl) +
                  " (" +
                  modelReserva.cant_dias +
                  " días)",
                alignment: "center",
              },
              {
                fontSize: 10,
                text: "\n" + campoFacturaPrecioAlquiler + " €",
                alignment: "center",
              },
              {
                fontSize: 10,
                text: "\n" + importeAlquiler + " €",
                alignment: "center",
              },
            ],

            modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml > 0?
            [
              {
                fontSize: 10,
                text: "",
              },
              {
                fontSize: 10,
                text:
                  "\n" +
                  (modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml) +
                  " (" +
                  modelReserva.cant_dias +
                  " días)",
                alignment: "center",
              },
              {
                fontSize: 10,
                text: "\n" + campoFacturaPrecioAlquilerMuscular + " €",
                alignment: "center",
              },
              {
                fontSize: 10,
                text: "\n" + importeAlquilerMuscular + " €",
                alignment: "center",
              },
            ]: ["", "", "", ""],







            campoFacturaPrecioTransporte != "" &&
            campoFacturaPrecioTransporte > 0
              ? [
                  {
                    fontSize: 10,
                    text: campoFacturaDescripcionTransporte,
                  },
                  {
                    fontSize: 10,
                    text: "1",
                    alignment: "center",
                  },
                  {
                    fontSize: 10,
                    text: campoFacturaPrecioTransporte + " €",
                    alignment: "center",
                  },
                  {
                    fontSize: 10,
                    text: campoFacturaPrecioTransporte + " €",
                    alignment: "center",
                  },
                ]
              : ["", "", "", ""],

            ["", "", "", ""],

            [
              {
                text: "",
                fillColor: "#DCEBF7",
              },
              {
                text: "",
                fillColor: "#DCEBF7",
              },
              {
                text: "",
                fillColor: "#DCEBF7",
              },
              {
                text: "",
                fillColor: "#DCEBF7",
              },
            ],
            ["", "", "", ""],

            [
              "",
              {
                colSpan: 2,
                text: "BASE IMPONIBLE:",
                alignment: "right",
              },
              "",
              {
                text: baseImponible + " €",
                fillColor: "#DCEBF7",
                alignment: "center",
              },
            ],
            ["", "", "", ""],
            [
              "",
              {
                colSpan: 2,
                text: "IVA (21%)",
                alignment: "right",
              },
              "",
              {
                text: iva,
                fillColor: "#DCEBF7",
                alignment: "center",
              },
            ],
            ["", "", "", ""],
            [
              "",
              {
                colSpan: 2,
                text: "TOTAL:",
                alignment: "right",
                bold: true,
              },
              "",
              {
                text: total + " €",
                fillColor: "#DCEBF7",
                alignment: "center",
                bold: true,
              },
            ],
            ["", "", "", ""],
            modelReserva.descuento != null && modelReserva.descuento != '0.00'?
            [
              "",
              {
                colSpan: 2,
                text: "DESCUENTO:",
                alignment: "right",
                
              },
              "",
              {
                text: modelReserva.descuento + " €",
                fillColor: "#DCEBF7",
                alignment: "center",
                
              },
            ]:["", "", "", ""],
            ["", "", "", ""],
            modelReserva.descuento != null && modelReserva.descuento != '0.00'?
            [
              "",
              {
                colSpan: 2,
                text: "TOTAL FINAL:",
                alignment: "right",
                bold: true,
              },
              "",
              {
                text: totalFinal + " €",
                fillColor: "#DCEBF7",
                alignment: "center",
                bold: true,
              },
            ]:["", "", "", ""],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [100, 20, "*"],
          body: [
            [
              {
                border: [false, false, false, true],
                text: "FORMA DE PAGO:",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                text: "ABANCA: ES83 2080 0306 5130 4002 5574",
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                text: "BIC: CAGLESMMXXX",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*"],
          heights: [1, 100, 1],
          body: [
            [
              {
                text: "",
                fillColor: "#CCCCCC",
              },
            ],
            [
              {
                fontSize: 8,
                text:
                  "Responsable del tratamiento: David Fragío Agra, CIF: 44831130- J Dir. Postal: SABAXANS Nº 47 - 15280-BRIÓN- A CORUÑA. Teléfono: 699331965 Correo electrónico: info@ebikecompostela.es" +
                  "En nombre de la empresa tratamos la información que nos facilita con el fin de prestarle el servicio solicitado y realizar la facturación del mismo, la cual se conservará mientras se mantenga" +
                  "la relación comercial o durante el tiempo necesario para cumplir con las obligaciones legales y atender las posibles responsabilidades que pudieran derivar del cumplimiento de la" +
                  "finalidad para la que los datos fueron recabados, y no se cederán a terceros salvo en los casos en que exista una obligación legal, ni se elaborará ningún tipo de “perfil”. Podrá ejercer los" +
                  "derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, portabilidad de datos y a no ser objeto de decisiones individualizadas, automatizadas, en relación con" +
                  "los datos objeto del tratamiento, ante esta entidad, vía e-mail, personalmente o mediante correo postal, adjuntando copia de su DNI o documento equivalente. En caso de que no haya" +
                  "obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia Protección de Datos competente, siendo ésta la AGPD y" +
                  "cuyos datos de contacto están accesibles en https://sedeagpd.gob.es/sede-electronica-web/vistas/formNuevaReclamacion/reclamacion.jsf.",
              },
            ],
            [
              {
                text: "",
                fillColor: "#CCCCCC",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
  };

  return docDefinition;
}

export async function reporteContrato(
  context,
  [
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    campoContratoHoraInicio,
    campoContratoHoraFin,
    campoContratoCasco,
    campoContratoCandado,
    campoContratoCargador,
    campoContratoKitPinchazos,
    campoContratoAlforjas,
    campoContratoBateriaExtra,
    campoContratoObservaciones,
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Contrato de Alquiler de Bicicletas",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [80, 100, "*"],
          body: [
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Fecha: ",
                bold: true,
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [140, 40, "*"],
          body: [
            [
              {
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Datos Arrendador",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nombre y Apellidos",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "44831130-J",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "David Fragio Agra",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Domicilio",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: "Lugar de Sabaxans nº 48 - Brión",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Teléfono",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "699 331 965",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "info@ebikecompostela.es",
                color: "#1E88E5",
              },
            ],

            [
              {
                margin: [0, 20, 0, 0],
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Datos Arrendatario",
              },
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nombre y Apellidos",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Domicilio",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Teléfono",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
                color: "#1E88E5",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 40, 0, 0],
        table: {
          widths: [60, 60, 20, 60, 60, 20, "*", "*"],
          body: [
            [
              {
                colSpan: 8,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Objeto del Contrato",
              },
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Casco",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoCasco,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                colSpan: 3,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Cantidad de Bicicletas",
              },
              "",
              "",
              {
                colSpan: 5,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Número",
              },
              "",
              "",
              "",
              "",
            ],

            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionBicisNumero(modelReserva),
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Candado",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCandado,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Hora Inicio",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraInicio,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                text: "",
              },

              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Hora Fin",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraFin,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Cargador",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCargador,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Kit Pinchazos",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoKitPinchazos,
                fontSize: 10,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "Importe Alquiler",
                fontSize: 10,
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Alforjas",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoAlforjas,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: modelReserva.total + " €",
                fontSize: 10,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Bateria Extra",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoBateriaExtra,
                fontSize: 10,
                alignment: "center",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 30, 0, 0],
        table: {
          widths: ["*"],
          heights: [10, 80],
          body: [
            [
              {
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Observaciones",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: campoContratoObservaciones,
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                colSpan: 2,
                margin: [0, 20, 0, 10],
                fontSize: 16,
                text: "\n\nTÉRMINOS Y CONDICIONES ESPECÍFICAS DEL CONTRATO",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "1.- El presente contrato de arrendamiento tendrá duración de ",
                  {
                    text: modelReserva.cant_dias,
                    fontSize: 10,
                    bold: true,
                  },
                  " días.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "2.- Las bicicletas se recogerán y entregarán en el horario establecido que va desde las 08:00 horas a las 21:00 horas todos los días de la semana.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                fontSize: 10,
                text: [
                  "La devolución de la/s bicicleta/ y material alquilado se llevará a cabo en el lugar del arrendamiento, en el día ",
                  {
                    text: _captionFecha(modelReserva.fecha_final),
                    fontSize: 10,
                    bold: true,
                  },
                  " y a la hora: ",
                  {
                    text: "21:00",
                    fontSize: 10,
                    bold: true,
                  },
                  ". El incumplimiento de la hora de entrega ocasionará un cargo adicional al cliente de 10 euros por hora de retraso. De no realizar la entrega en el día estipulado en el contrato, el cargo adicional ocasionado, será de 45 euros. Al no realizar la entrega, el arrendador podrá tomar posesión inmediata la bicicleta en el lugar donde se encuentre, sin tener derecho a reclamación alguna por parte del arrendatario.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "3.- La franja horaria de alquiler queda comprendida: Día completo: 08:00 a 21:00 horas.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "4.- El material se devolverá completo y en el mismo estado en el que se le entregó al cliente. El coste por reparación o reposición de la bicicleta y/o del material correrá a cargo del cliente. El cliente deberá informar al arrendador, de los daños ocasionados en dicho material o del mal funcionamiento del mismo. El cliente esta obligado a tener buen cuidado y tomar todas las precauciones necesarias para proteger las bicicletas y el equipo alquilado de daños, perdida o robo. De producirse cualquiera de las mencionadas situaciones durante el periodo de alquiler, el cliente asumirá de manera inmediata la totalidad de los costes de reposición ocasionados a precio de tarifa o de mercado según el arrendador disponga o no de la pieza a reponer. Al final del periodo de alquiler el arrendador, determinará las condiciones de entrega del material alquilado y valorará dado el caso, las pérdidas o daños ocasionados. El cliente está obligado en todo momento a fijar correctamente con el candado y cadena de seguridad la/s bicicleta/s cuando no las tenga a la vista (pasar el candado por el cuadro, sillín y ruedas y atar la bicicleta aun poste fijado al suelo o bici parking).",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "5.- El arrendatario declara estar en perfectas condiciones de salud, ser capaz de manejar una bicicleta y poseer el control necesario del equipamiento alquilado.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "6.- En este acto el arrendatario entrega al arrendador, una ",
                  {
                    text: "fianza de " + modelReserva.fianza + " euros",
                    fontSize: 10,
                    bold: true,
                  },
                  " mediante tarjeta de crédito que servirá para responder de los posibles daños causados a la bicicleta o el equipamiento alquilado, dicha fianza será reembolsada al finalizar el contrato. En caso de pérdida o robo de la bicicleta, el arrendador perderá todo el derecho a la fianza, debiendo comunicar de inmediato tal circunstancia. Además, deberá proceder a indemnizar al arrendatario por la cantidad estipulada según precio de mercado.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "7.- El alquiler de bicicleta no incluye seguro de daños propios, por lo que el arrendatario es responsable de todos los daños de material o personales que pueda sufrir. El alquiler se realiza con la cobertura del correspondiente seguro de RC que cubre todos los daños causados por origen del alquiler a terceros, personas o bienes. Es responsabilidad del cliente y de su/s acompañante/s respetar las normas de tráfico españolas y conducir con cuidado y respetar a los peatones.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "8.- Los datos facilitados por el cliente, serán utilizados exclusivamente para la correcta prestación del servicio contratado, pudiendo solicitar, de acuerdo con la ley, su acceso, rectificación, cancelación u oposición mediante comunicación por cualquier medio al arrendador. Este contrato se rige por la ley española.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "9.- En caso de que el arrendador necesite asistencía en viaje sin que hubiese sido contratada con anterioridad, el coste será de 15€ hora, y 15€ de desplazamiento a la zona donde se encuentre el cliente.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "10.- En caso de que el arrendador decida devolver las bicicletas en fecha anterior a la finalizacion de este contrato, no tendrá derecho a la devolución alguna.",
              },
              "",
            ],
            [
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Firma del Arrendador",
              },
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Firma del Arrendatario - Contratante",
              },
            ],

            [
              {
                width: "auto",
                fit: [180, 100],
                image: imagenFirma,
                alignment: "left",
              },

              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
  };

  return docDefinition;
}
